<template>
    <el-tooltip :content="content" effect="dark">
        <i class="el-icon-question"></i>
    </el-tooltip>
</template>

<script>
export default {
    name: "HelpIcon",
    props: ["content"]
}
</script>

<style scoped>

</style>
